"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoRooms/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);



var _videoRoom = require('web/selectors/videoRoom');
var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');
var _App = require('web/screens/App');
var _RightSide = require('web/components/RightSide');
var _Header = require('web/components/RightSide/Header');

var _RoomBody = require('./RoomBody'); var _RoomBody2 = _interopRequireDefault(_RoomBody);
var _RoomHeader = require('web/screens/VideoRooms/RoomHeader'); var _RoomHeader2 = _interopRequireDefault(_RoomHeader);
var _List = require('./List'); var _List2 = _interopRequireDefault(_List);
var _EmptyRoom = require('web/components/VideoRooms/Room/EmptyRoom'); var _EmptyRoom2 = _interopRequireDefault(_EmptyRoom);
var _VideoRooms = require('web/components/Upsells/VideoRooms'); var _VideoRooms2 = _interopRequireDefault(_VideoRooms);


















// memo keeps the PureComponent / connect() bailout on unchanged props.
const VideoRooms = _react.memo.call(void 0, function VideoRooms ({
  roomKey,
  gotoMeeting, gotoRoom, gotoRoomsList,
  onRoomShare, onRoomLinkCopy,
  showNoticeBar,
  openMobileNewRoomModal, openDesktopNewRoomModal,
}) {
  const isRoomLoaded = _hooks.useAppSelector.call(void 0, state =>
    // SAFETY: as in the JS, a missing key looks up `undefined`, finding no room.
    !!_videoRoom.selectVideoRoomByKey.call(void 0, state, roomKey ))
  const areAnyRoomsListed = _hooks.useAppSelector.call(void 0, state => !!_videoRoom.selectAllVideoRoomsCount.call(void 0, state))
  const hasVideoFeature = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserHasVideoV2Feature)

  // Kept from the class: nothing reads this flag (no upsell modal renders), so
  // the upsell notice's request link only re-renders the screen.
  const [, setIsUpsellsModalOpen] = _react.useState.call(void 0, false)
  const openUpsellsModal = _react.useCallback.call(void 0, () => setIsUpsellsModalOpen(true), [])

  // componentDidMount (class timing): only the key the page opened with.
  // Later room changes go through gotoRoom, which sets the key itself.
  _react.useLayoutEffect.call(void 0, () => {
    if (!roomKey) return

    _actions2.default.setCurrentVideoRoomKey(roomKey)
    if (!isRoomLoaded) _actions2.default.fetchVideoRoom(roomKey)
  // oxlint-disable-next-line react-hooks/exhaustive-deps -- mount only, as in the class
  }, [])

  const isInRoom = !!roomKey && isRoomLoaded

  const renderRoomBody = (openRoomKey) => (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Header.RightSideHeader, { className: "meeting-rooms--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
        , _react2.default.createElement(_RoomHeader2.default, {
          roomKey: openRoomKey,
          onBack: gotoRoomsList,
          onRoomShare: onRoomShare,
          showNoticeBar: showNoticeBar,
          onRoomLinkCopy: onRoomLinkCopy,
          gotoMeeting: gotoMeeting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
        )
      )
      , _react2.default.createElement(_RightSide.RightSideBody, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
        /* The JS also passed showNoticeBar, which RoomBody never read. */
        , _react2.default.createElement(_RoomBody2.default, {
          key: openRoomKey,
          roomKey: openRoomKey,
          onRoomShare: onRoomShare,
          onRoomLinkCopy: onRoomLinkCopy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
        )
      )
    )
  )

  const renderEmptyRoom = () => (
    _react2.default.createElement(_RightSide.RightSideBody, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
      , _react2.default.createElement(_EmptyRoom2.default, {
        areRoomsAvailable: areAnyRoomsListed,
        openDesktopNewRoomModal: openDesktopNewRoomModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
      )
    )
  )

  return (
    _react2.default.createElement(_App.AppVertical, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}
      , _react2.default.createElement(_App.NavigationMenu, { className: "meeting-rooms--list-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
        , _react2.default.createElement(_List2.default, {
          hasVideoFeature: hasVideoFeature,
          onRequestVideoFeature: openUpsellsModal,
          gotoRoom: gotoRoom,
          currentRoomKey: roomKey,
          openMobileNewRoomModal: openMobileNewRoomModal,
          openDesktopNewRoomModal: openDesktopNewRoomModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
        )
      )
      , _react2.default.createElement(_RightSide.RightSide, {
        className: "meeting-room--right-side",
        inView: isInRoom && hasVideoFeature, __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}

        ,  !hasVideoFeature
          ? _react2.default.createElement(_VideoRooms2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 117}} )
          : isInRoom
            ? renderRoomBody(roomKey)
            : renderEmptyRoom()
        
      )
    )
  )
})

exports. default = VideoRooms
